import { Component, h, Host, Prop, Element } from '@stencil/core';
import { getSvgContent, buildIconUrl, TIconColors, TIconSize, cleanSVG } from './icon-utils';
import { injectCSS, SelectedAriaAttributes, parseAndGetAriaAttributes } from '../../utils';
import { createStyles } from './icon-styles';
import { TIcon } from '../../svg/icons';

const ICON_ARIA_ATTRIBUTES = ['aria-label', 'aria-hidden'] as const;
export type TIconAriaAttribute = (typeof ICON_ARIA_ATTRIBUTES)[number];

@Component({
  tag: 'dc-ui-icon',
  shadow: true,
})
export class DcUiIcon {
  @Element() public host!: HTMLElement;
  @Prop({ reflect: true, mutable: true }) name: TIcon = 'dc_home';
  @Prop({ reflect: true, mutable: true }) color: TIconColors = 'currentColor';
  @Prop() size: TIconSize = 'medium';
  @Prop() aria: SelectedAriaAttributes<TIconAriaAttribute>;
  @Prop() source: string;

  key = 0;
  svgContent = '';

  private loadIcon(): void {
    let url = buildIconUrl(this.name);

    if (this.source?.length) {
      url = buildIconUrl(this.source);
    }

    getSvgContent(url).then((svgContent) => {
      this.setIconContent(svgContent);
    });
  }

  private setIconContent(content: string): void {
    this.svgContent = cleanSVG(content);
    const cleanContent = cleanSVG(content);

    setTimeout(() => {
      const el = this.host.shadowRoot.querySelector('i');
      if (!el) return;
      el.innerHTML = cleanContent;
    }, 0);
  }

  public componentWillUpdate(): void {
    // reset old icon if there is any
    if (this.svgContent) {
      this.setIconContent('');
      this.loadIcon();
    }
  }

  async componentWillLoad() {
    this.loadIcon();
  }

  render() {
    injectCSS(this.host, createStyles, this.color, this.size);

    return (
      <Host>
        <i
          key={this.key++}
          {...parseAndGetAriaAttributes(this.aria)}
        />
      </Host>
    );
  }
}
